const BASE_PATH = "app/home/";

export const SET_HOME_APIS = `${BASE_PATH}set-home-apis`;
export const SET_LAYOUTS = `${BASE_PATH}set-home-layouts`;
export const SET_SCROLL_POSITION = `${BASE_PATH}set-home-scroll-position`;
